<span class="countdown-timer-time-left" [ngClass]="{'countdown-timer-time-left-auction-ended': auctionEnded || !auctionStarted}">
  {{this.days}}d {{this.hours}}h {{this.minutes}}m {{this.seconds}}s
</span>
